export default __webpack_public_path__ + "assets/love.cb0d496.mp3";